/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCurrencyField
 */
export interface DatabaseCurrencyField extends DatabaseField {
    /**
     * 
     * @type {Currency}
     * @memberof DatabaseCurrencyField
     */
    type?: Currency;
    /**
     * 
     * @type {number}
     * @memberof DatabaseCurrencyField
     */
    defaultValue?: number;
}

/**
 * Check if a given object implements the DatabaseCurrencyField interface.
 */
export function instanceOfDatabaseCurrencyField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCurrencyFieldFromJSON(json: any): DatabaseCurrencyField {
    return DatabaseCurrencyFieldFromJSONTyped(json, false);
}

export function DatabaseCurrencyFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCurrencyField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : CurrencyFromJSON(json['type']),
        'defaultValue': !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
    };
}

export function DatabaseCurrencyFieldToJSON(value?: DatabaseCurrencyField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': CurrencyToJSON(value.type),
        'defaultValue': value.defaultValue,
    };
}

